import result from '@modules/Recruiting/Result';

export const validateForms = (forms) => {
  const values = Promise.all(
    Object.values(forms).map((form: any) => form.validateFields())
  );
  
  return values;
}